import React, { useContext } from "react";
import { 
  Card, 
  CardContent, 
  TextField, 
  Typography, 
  Grid,
  InputAdornment,
  Divider
} from "@mui/material";
import { 
  Business as BusinessIcon, 
  Phone as PhoneIcon, 
  Email as EmailIcon, 
  LocationOn as LocationIcon,
  Work as WorkIcon
} from "@mui/icons-material";
import { Context } from "../../context";
import { MEDICAL_BILLING_PERSON } from "../../config";

const EmploymentField = ({
  label,
  name,
  value,
  updateEmployment,
  painConsultNoteSigned,
  icon,
  placeholder,
  type = "text",
  multiline = false
}) => {
  const { user } = useContext(Context);
  
  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      margin="dense"
      label={label}
      value={value || ""}
      name={name}
      onChange={(e) => updateEmployment(e)}
      disabled={(user && user.role === MEDICAL_BILLING_PERSON) }
      placeholder={placeholder}
      type={type}
      multiline={multiline}
      rows={multiline ? 2 : 1}
      InputProps={{
        startAdornment: icon ? (
          <InputAdornment position="start">
            {icon}
          </InputAdornment>
        ) : null
      }}
    />
  );
};

const Employment = ({ employment, setEmployment, painConsultNoteSigned }) => {
  const updateEmployment = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setEmployment((values) => ({ ...values, [name]: value }));
  };

  return (
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <WorkIcon sx={{ mr: 1 }} color="info" /> 
          Employment Information
        </Typography>
        
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EmploymentField
              label="Employer Name"
              name="employer"
              value={employment.employer}
              updateEmployment={updateEmployment}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<BusinessIcon color="info" fontSize="small" />}
              placeholder="Company or organization name"
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <EmploymentField
              label="Business Phone"
              name="business_phone"
              value={employment.business_phone}
              updateEmployment={updateEmployment}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<PhoneIcon color="info" fontSize="small" />}
              placeholder="(555) 123-4567"
              type="tel"
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <EmploymentField
              label="Business Email"
              name="business_email"
              value={employment.business_email}
              updateEmployment={updateEmployment}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<EmailIcon color="info" fontSize="small" />}
              placeholder="work@example.com"
              type="email"
            />
          </Grid>
          
          <Grid item xs={12}>
            <EmploymentField
              label="Work Address"
              name="work_address"
              value={employment.work_address}
              updateEmployment={updateEmployment}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<LocationIcon color="info" fontSize="small" />}
              placeholder="Complete workplace address"
              multiline={true}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Employment;